import { useLocale, useTranslations } from 'next-intl';
import { Option, DetailedTimeslot, EnumOptionKind } from 'src/types';
import dayjs from 'dayjs';
import { getDurationDay, getTotalQty } from 'src/helpers';

const DisplaySelectedInfo: React.FC<{
  option: Option;
  bookingFormValues: {
    startDate: string | null;
    endDate: string | null;
    detailedTimeslotId: number | null;
    quantity: number;
    localQuantity: number;
    childLocalQuantity: number;
    childQuantity: number;
  };
  detailedTimeslots: DetailedTimeslot[];
  hidePrice?: boolean;
}> = ({ option, bookingFormValues, detailedTimeslots, hidePrice }) => {
  const translation = useTranslations('components.DisplaySelectedInfo');
  const locale = useLocale();
  const currentDetailedTimeslot = detailedTimeslots.find(
    (o) => o.id === bookingFormValues.detailedTimeslotId
  );

  const totalQty = getTotalQty(bookingFormValues);
  const calendarPriceUnit =
    totalQty === 0
      ? ''
      : translation('pluralizePerson', {count: totalQty})

  const text = [
    !hidePrice && totalQty > 0 ? `${translation('price')} ${calendarPriceUnit}` : null,
    bookingFormValues.startDate && dayjs(bookingFormValues.startDate).format('DD MMM'),
    bookingFormValues.endDate && dayjs(bookingFormValues.endDate).format('DD MMM'),
    !bookingFormValues.endDate &&
      bookingFormValues.startDate &&
      option.kind === EnumOptionKind.adventure &&
      getDurationDay(option) > 0 &&
      dayjs(bookingFormValues.startDate).add(getDurationDay(option), 'day').format('DD MMM'),
    bookingFormValues.startDate && bookingFormValues.endDate && option.kind === EnumOptionKind.stay
      ? translation('pluralizeNight',{count: dayjs(bookingFormValues.endDate).diff(bookingFormValues.startDate, 'day')})
      : null,
    currentDetailedTimeslot && dayjs(currentDetailedTimeslot.startTime).format('HH:mm'),
  ]
    .filter((v) => v)
    .join(' - ');
  return <span>{text}</span>;
};

export default DisplaySelectedInfo;
